import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      class: "form-control me-3 my-1",
      type: "text",
      placeholder: "New Email"
    }, null, 512), [
      [_vModelText, _ctx.inputValue]
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary btn-sm mx-2",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeUserEmail && _ctx.changeUserEmail(...args)))
    }, " Update "),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-danger btn-sm mx-2",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deactivateComponentFunc()))
    }, " Close ")
  ], 64))
}